import { Snop } from "../../../../assets/svg-icons";
export const SNOE = {
    name: "S&OE",
    shortName: "S&OE",
    route: "/snoe",
    icon: Snop,
    permissions: ["SNOE_VIEW"],
};
